import { RewardsEligibility } from "@arbolus-technologies/models/common";

export const SET_REWARDS_ELIGIBILITY = "CACHE_SET_REWARDS_ELIGIBILITY";

export interface SetRewardsEligibilityAction {
  type: typeof SET_REWARDS_ELIGIBILITY;
  payload: {
    rewardsEligibility: RewardsEligibility;
  };
}
